// extracted by mini-css-extract-plugin
export default {"root":"DocumentLink_root__uHU5l","fileTitle":"DocumentLink_fileTitle__FMF3D"};